<template>
  <div>
    <div class="sm:py-12 sm:px-4 md:px-6">
      <FilterBar
        v-model="filters"
        :categories="businessCategories"
        :subcategories="businessCategories"
      />

      <div>
        <div class="overflow-hidden bg-white shadow-sm dark:bg-gray-800 sm:rounded-lg">
          <div class="p-6 text-gray-900 dark:text-gray-100">
            <div v-if="businesses.length === 0" class="py-8 text-center">
              <p class="text-gray-500 dark:text-gray-400">No businesses found.</p>
            </div>
            <div v-else class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
              <div
                v-for="business in businesses"
                :key="business.id"
                class="overflow-hidden bg-white rounded-lg border border-gray-200 shadow-md backdrop-blur-sm transition-shadow duration-300 dark:border-gray-700 dark:bg-gray-700 hover:shadow-lg"
              >
                <RouterLink :to="user ? {name: ROUTES.BUSINESS, params: {id: business.uuid}} : {name: ROUTES.PUBLIC_BUSINESS, params: {id: business.uuid}}" class="block" @click="mixpanel.track('View Business', { distinct_id: user.id, business_name: business.name, business_id: business.uuid, business_address: business.address, business_phone: business.phone, business_email: business.email })">
                  <div class="p-6">
                    <div v-if="business.logo_url" class="mb-4 w-20 h-20">
                      <img :src="business.logo_url" alt="Business Logo" class="object-cover w-full h-full rounded-full" />
                    </div>
                    <div v-else class="flex justify-center items-center w-20 h-20 bg-gray-200 rounded-full dark:bg-black">
                      <span class="text-2xl font-semibold text-gray-600 dark:text-gray-300">
                        {{ getInitials(business.name) }}
                      </span>
                    </div>
                    <h3 class="mb-2 text-xl font-semibold dark:text-white">{{ business.name }}</h3>
                    <p class="mb-4 text-gray-600 dark:text-gray-300 line-clamp-2">
                      {{ business.description }}
                    </p>
                    <div class="flex justify-between items-center">
                      <div class="flex items-center">
                        <div class="flex">
                          <template v-for="i in 5" :key="i">
                            <StarIcon
                              :class="[
                                'h-5 w-5',
                                i <= (business.rating || 0) ? 'text-yellow-400' : 'text-gray-300'
                              ]"
                            />
                          </template>
                        </div>
                        <span class="ml-2 text-sm text-gray-500 dark:text-gray-400">
                          ({{ business.review_count || 0 }} reviews)
                        </span>
                      </div>
                      <span class="text-sm text-gray-500 dark:text-gray-400">
                        {{ (business.rating || 0).toFixed(1) }}
                      </span>
                    </div>
                    <div class="mt-4">
                      <p class="text-sm text-gray-500 dark:text-gray-400">
                        {{ business.address }}
                      </p>
                    </div>
                  </div>
                </RouterLink>
              </div>
            </div>

            <!-- Pagination -->
            <div v-if="pagination.links && pagination.links.length > 3" class="flex justify-end mt-8">
              <PaginationComponent :links="pagination.links" @page-change="onPageChange" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PaginationComponent from '@/components/general/PaginationComponent.vue'
import { StarIcon } from '@heroicons/vue/24/solid'
import { useBusinessStore } from '@/stores/businessStore';
import { storeToRefs } from 'pinia'
import { ref, reactive, onMounted, watch } from 'vue'
import { ROUTES } from '@/router/routeNames'
import { useAuthStore } from '@/stores/authStore'
import FilterBar from '@/components/general/FilterBar.vue'
import mixpanel from '@/services/mixpanel'
const businessStore = useBusinessStore()
const { businesses, isLoadingBusinesses, pagination, } = storeToRefs(businessStore)
const { fetchBusinesses } = businessStore;
const authStore = useAuthStore()
const { user } = storeToRefs(authStore)
import { businessCategories } from '@/constants';
import { getInitials } from '@/utils'
const filters = ref({ search: '', category: '', subcategory: '' })

// async function fetchCategories() {
//   // const res = await fetch('/api/categories')
//   categories.value = []
// }
// async function fetchSubcategories() {
//   // const res = await fetch('/api/sub-categories')
//   subcategories.value = []
// }

function applyFilters() {
  fetchBusinesses({ ...filters.value }, 1);
}

function onPageChange(page) {
  fetchBusinesses({ ...filters.value }, page);
}

onMounted(() => {
  // fetchCategories()
  // fetchSubcategories()
  fetchBusinesses({ ...filters.value }, 1)
})

watch(() => filters.value, applyFilters, { deep: true })

</script>
